import styled from 'styled-components'

export const RecentActivityContainer = styled.div`
  .title-container {
    padding-bottom: 0.5rem;
  }
`
